module.exports = __webpack_public_path__ + "img/home_icon.decb3012.svg";